import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

/**
 * Application Bootstrap
 *
 * Sentry initialization has been moved to SentryService to ensure GDPR compliance.
 * Sentry.init() is only called when user explicitly gives Analytics consent.
 *
 * The SentryService is injected in AppComponent and automatically manages
 * Sentry initialization based on cookie consent preferences.
 */
bootstrapApplication(AppComponent, appConfig);
